import React from 'react'
import { preToCodeBlock } from 'mdx-utils'

// components
import Code from './Code'
import Blockquote from './Blockquote'
import { OrderedList, UnorderedList } from './List'
import Anchor from './Anchor'
import Kbd from './Kbd'
import H2 from './H2'

import Image from './Image';

const MdxComponents = {
  pre: preProps => {
    const props = preToCodeBlock(preProps)
    if (props) {
      return <Code {...props} />
    } else {
      return <pre {...preProps} />
    }
  },
  blockquote: (props) => <Blockquote {...props} />,
  ol: props => <OrderedList {...props} />,
  ul: props => <UnorderedList {...props} />,
  a: props => <Anchor {...props} />,
  kbd: props => <Kbd {...props} />,
  h2: props => <H2 {...props} />,
  img: props => <Image {...props}/>
}

export default MdxComponents;